import { Directive } from '@angular/core';
import { IfTradeStoreDirective } from './if-trade-store.directive';
@Directive({
    selector: '[ifNotTradeStore]',
    standalone: true
})
export class IfNotTradeStoreDirective extends IfTradeStoreDirective {
    protected override check(): boolean {
        return !super.check();
    }
}
